import { withDomains } from "../lib/domain";
import React, { useEffect, useState } from "react";
import { RESTExecutor } from "../lib/domain";
import { Link } from "react-router-dom";
import {
  Row,
  Space,
  Menu,
  Divider,
  Dropdown,
  message,
  Button,
  Tooltip,
  Modal,
  Tabs,
  Col
} from "antd";
import { CustomButton } from "../components/forms/buttons";
import CompanyDetailCard from "../components/company_detail_card";
import {
  PlusOutlined,
  PlusCircleOutlined,
  SettingOutlined,
  LogoutOutlined,
  MailOutlined,
  CloseOutlined,
  ExclamationCircleOutlined,
  MoreOutlined,
  UnorderedListOutlined,
  CheckOutlined,
} from "@ant-design/icons";
import { BASE_API_URL } from "../config";
import Text from "antd/lib/typography/Text";
import { getImageUrl } from "../util/ui_util";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { GridLayout, SearchIcon, WarnIcon } from "../assets/icons";
import { HomeTabs } from "../components/home-tabs";
import { TopHeader } from "../components/top-header";
import { ViewSwitch } from "../components/ViewSwitch";
import { CardTitle, GridView } from "./organization-list";

let userName = "";
let imgSource = "";
const { confirm } = Modal;

const InvitationList = ({ domains, authenticator, ...props }) => {
  const [loading, setLoading] = useState(true);

  let namespace_invitations = RESTExecutor.list()
    .config({
      label: "namespace_invitations",
      params: { status: "Pending" },
    })
    .callbacks((success) => {
      setLoading(false);
    },(error) => {setLoading(false)})
    .connect(domains.user);

  let respond_to_invitation = RESTExecutor.post()
    .config({
      label: "respond_to_invitation",
    })
    .callbacks(
      (success) => {
        namespace_invitations.execute(true);
      },
      (error) => {
        message.error(error?.error_message);
      }
    )
    .connect(domains.user);

  useEffect(() => {
    namespace_invitations.execute(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  

  let invitations_resp = namespace_invitations.response();

  const invitationsMenu = (inviteId) => {
    return (
      <Menu>
        <Menu.Item
          icon={<MailOutlined />}
          onClick={() => {
            let data = { accept: false, id: inviteId };
            function rejectInvitation() {
              respond_to_invitation.execute(data);
            }
            showPromiseConfirm(
              "Do you really want to reject this invitation?",
              rejectInvitation
            );
          }}
        >
          Reject Invitation
        </Menu.Item>
        {/* <Menu.Item
            icon={<MailOutlined />}
            onClick={() => {
              window.open(`mailto:${email}?subject=${title}`)
            }}
          >
            Contact Admin
          </Menu.Item> */}
      </Menu>
    );
  };

  function showPromiseConfirm(title, ok) {
    confirm({
      title: title,
      content: "This action cannot be reversed",
      icon: <ExclamationCircleOutlined />,
      onOk() {
        ok();
      },
      onCancel() {},
    });
  }

  const onAcceptInvitation = ({ id }) => {
    let data = { accept: true, id: id };

    function acceptInvite() {
      respond_to_invitation.execute(data);
    }

    showPromiseConfirm(
      "Do you really want to accept this invitation?",
      acceptInvite
    );
  };

  if(invitations_resp?.result?.length === 0) {
    return (
      <div
      style={{
        minHeight:
         '100%',
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "32px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "16px",
          }}
        >
          <img src="images/empty_state.svg" alt="Empty state" />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
            }}
          >
            <Text
              style={{
                fontSize: "16px",
                fontWeight: "600",
                lineHeight: "20.8px",
                color: "#343C46",
                textAlign: "center",
              }}
            >
              No Pending Invitations!
            </Text>
          
          </div>
        </div>
      
      </div>
    </div>
    )
  }


  return (
    <div
      className="comapny-card-menu-invites"
     
    >
      <div className="company-card-menu-header">Invitations</div>
      <GridView data={invitations_resp?.result} isLoading={loading}>
        {(invitations_resp.result ?? []).map((item = {}) => (
          <>
            <InvitationCard
              data={item}
              invitationMenu={invitationsMenu(item?.id)}
              onAcceptInvitation={onAcceptInvitation}
            />
          </>
        ))}
      </GridView>
    </div>
  );
};

const InvitationCard = ({ data, onAcceptInvitation, invitationMenu }) => {
  const subTitle = `${data?.company?.slug}.tigg.app`;
  const title = data?.company?.name;

  const avatar = getImageUrl(data?.company)
    ? getImageUrl(data?.company)
    : `https://ui-avatars.com/api/?name=${
        data?.company?.display_name?.split(" ")[0]
      }+${
        data?.company?.display_name?.split(" ")[1]
      }&background=393965&color=fff`;

  return (
    <Col xs={24} md={8} xl={6}>


    <div className="invitation_card border_layout">
      <div className="invitation_card__header">
        <div style={{ marginLeft: "auto" }}>
          <Dropdown overlay={invitationMenu} trigger={["click"]}>
            <MoreOutlined />
          </Dropdown>
        </div>
      </div>

      <div className="invitation_card__body">
        <>
          <img src={avatar} alt={data?.slug} />
          <div
            style={{
              gap: "4px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign:"center",
              paddingLeft: '12px',
              paddingRight:'12px'
            }}
          >
          <CardTitle title={title} />
            <div
              style={{
                fontSize: "13px",
                fontWeight: "400",
                color: "var(--gray50)",
              }}
            >
              {subTitle}
            </div>
          </div>
        </>

        <div
          style={{ color: "var(--gray60)", fontSize: "14px", fontWeight: 400 }}
        >
          Invited by {data?.referred_by?.name}
        </div>
      </div>
      <div className="invitation_card__footer">
        <Button
          icon={<CheckOutlined />}
          //   loading={companies_resp?.fetching}
          style={{ color: "var(--btn-success)" }}
          onClick={() => {
            onAcceptInvitation({ id: data?.id });
          }}
        >
          Accept Invitation
        </Button>
      </div>
    </div>
    </Col>
  );
};
export default withDomains(
  InvitationList,
  "user",
  "auth",
  "upgradeCredentials",
  "register"
);
